export const formatChurnRate = rate => (rate > 0 ? (rate * 100 * 100) / 100 : 0);
